import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, ModalController, AlertController, LoadingController } from '@ionic/angular/lazy';
import { APIService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { ObserverService } from 'src/app/services/observer.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-organisation-options',
    templateUrl: './organisation-options.component.html',
    styleUrls: ['./organisation-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrganisationOptionsComponent implements OnInit {

    @Input() organisation_page = null;
    @Input() organisation = null;
    @Input() organisation_id = null;
    spinner = null;

    constructor(
        private popoverCtrl: PopoverController,
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private apiService: APIService,
        private authService: AuthService,
        private router: Router,
        private observerService: ObserverService,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async dismiss() {
        try {
            await this.popoverCtrl.dismiss();
        } catch (e) {
            // click more than one time popover throws error, so ignore...
        }
    }

    public edit() {
        this.organisation_page.presentEditModal();
        this.dismiss();
    }

    public addStoreCredit() {
        this.organisation_page.presentAddStoreCreditModal();
        this.dismiss();
    }

    public removeStoreCredit() {
        this.organisation_page.presentRemoveStoreCreditModal();
        this.dismiss();
    }

    public archiveOrganisation() {
        this.presentSpinner("Archiving organisation").then(() => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.updateOrganisation(this.organisation_id, {archived: true}).then((organisation) => {
                    this.observerService.publish("organisation_updated", organisation);
                    this.spinner.dismiss();
                    this.dismiss();
                })
                .catch((error) => {
                    if (error) {
                        if (error.status === 400) {
                            this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to archive this organisation.");
                        }
                        else if (error.status === 403) {
                            this.presentAlert("Insufficient permissions", "You don't have permission to archive this organisation.");
                        }
                        else if(error.status == 404) {
                            this.presentAlert("Unavailable", "Unfortunately we're unable to archive this organisation at this time.");
                        }
                        else if(error.status == 0) {
                            this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                        }
                    }
                    this.spinner.dismiss();
                    this.dismiss();
                });
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    public unarchiveOrganisation() {
        this.presentSpinner("Unarchiving organisation").then(() => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.updateOrganisation(this.organisation_id, {archived: false}).then((organisation) => {
                    this.observerService.publish("organisation_updated", organisation);
                    this.spinner.dismiss();
                    this.dismiss();
                })
                .catch((error) => {
                    if (error) {
                        if (error.status === 400) {
                            this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to unarchive this organisation.");
                        }
                        else if (error.status === 403) {
                            this.presentAlert("Insufficient permissions", "You don't have permission to unarchive this organisation.");
                        }
                        else if(error.status == 404) {
                            this.presentAlert("Unavailable", "Unfortunately we're unable to unarchive this organisation at this time.");
                        }
                        else if(error.status == 0) {
                            this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                        }
                    }
                    this.spinner.dismiss();
                    this.dismiss();
                });
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    async presentSpinner(message: string) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
        });
        await this.spinner.present();
    }

}
